var url_path = window.location.pathname;
if (url_path == '/products' || url_path == '/products/'){

  window.location.href = "/collections/all";
}

function addToCartEventFB(){
  fbq('track', 'AddToCart');
}

$(window).on('load', function() {

    // -------- Klavyio form submit + FB lead
    window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'submit') {
            fbq('track', 'Lead');
        }
    });

  // PAGEFLY 
  try {
    //setTimeout(function () {
      window.__pagefly_helper_store__ &&
        window.__pagefly_helper_store__.subscribe(function (res) {
          ajaxCart.load()
      });
    //}, 2500);
  } catch (e) {
    console.warn(e);
  }
  // PAGEFLY

  
  $(".ga-product_addtocart").on('click', function(){
    $(".js-drawer-open-button-right").click();
  });
  
  $(".qsc-btn--add-to-cart").on('click', function(){
    $(".js-drawer-open-button-right").click();
  });

  /* --------Size chart events------- */
  $('.pf-m').before().click(function() {
    $(".pf-o").click();
  });

  /* ------ replacing pagefly div links to add currency -------*/
    // Extract the language code from the current URL
    var languageCodeMatch = window.location.href.match(/https:\/\/orthoflexx\.com\/(en-[a-z]{2})/);

    if (languageCodeMatch) {
        var languageCode = languageCodeMatch[1]; // Captures 'en-[two letters]'

        // Find all links within the specified div and update them
        $('.js-insoles-links a[href^="/products/"]').each(function() {
            var newHref = $(this).attr('href').replace('/products/', `/${languageCode}/products/`);
            $(this).attr('href', newHref);
        });
    }

});


/* ----- colapsable js ----*/
var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    
    this.classList.toggle("active");

    var content = this.nextElementSibling;
    
    content.classList.toggle("active");
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}
/* ----- colapsable js ----*/


// Trigger add to cart facebook pixel
/* 
$(".btn--add-to-cart").on('click', function(){
  addToCartEventFB();
});

// hide ship from
//$("#SingleOptionSelector-1").parent().hide();
if($("#SingleOptionSelector-0").parent().find('label').text().indexOf("Ships From") >= 0) {
    $("#SingleOptionSelector-0").parent().hide()
}
if($("#SingleOptionSelector-1").parent().find('label').text().indexOf("Ships From") >= 0) {
    $("#SingleOptionSelector-1").parent().hide()
}
if($("#SingleOptionSelector-0").parent().find('label').text().indexOf("Colors") >= 0) {
    $("#SingleOptionSelector-0").parent().hide()
}
*/
